import React from "react";

import { css } from "@emotion/react";

import { type ProductVariantAvailabilityStatus } from "@swo/shared";
import { SimpleAspectRatio } from "../../../components/_shared-components/SimpleAspectRatio";
import { CSS_MQ } from "../../../styles/breakpoints";
import { PDPAboveTheFoldMainImage } from "../PDPAboveTheFoldMainImage";
import { PdpGalleryWithLightboxProps } from "../PDP_Lightbox/use-pdp-gallery-with-lightbox";
import { RibbonTextElement } from "../RibbonTextElement";

export const PDPImageWithPlaceholder: React.FC<{
  galleryWithLightbox: PdpGalleryWithLightboxProps;
  availability: ProductVariantAvailabilityStatus | null;
}> = ({ galleryWithLightbox, availability }) => {
  return (
    <>
      <div
        css={css`
          display: none;
          ${CSS_MQ.atLeastMd} {
            display: block;
            grid-column: 1 / span 1;
            grid-row: 1 / span 1;

            visibility: hidden;
          }
        `}
        className={"placeholder-element"}
      >
        <SimpleAspectRatio as={"div"} />
      </div>

      <div
        className="u-relative"
        css={css`
          ${CSS_MQ.atLeastMd} {
            grid-column: 1 / span 1;
            grid-row: 1 / span 2;
          }
        `}
      >
        <PDPAboveTheFoldMainImage
          galleryWithLightbox={galleryWithLightbox}
          ribbonTextElement={<RibbonTextElement availability={availability} />}
        />
      </div>
    </>
  );
};
